import {
    Button,
    MobilePage,
    MobilePageActions,
    MobilePageSection,
    StatusLabel,
} from "@relode/core";
import { JobCandidateStatus, Routing } from "@relode/core/domain";
import * as React from "react";

import {
    CandidateHighlights,
    CandidateJobDetailsMobile,
    CandidateResumeMobile,
    InterviewAvailability,
    JobManagerContactDetails,
} from "../../../../shared/components/candidate";
import {
    useClientPublicCandidateContext,
} from "../_infra/clientPublicCandidateProvider";

export const ClientPublicCandidateDetailsMobile = () => {
    const {
        state: {
            data: { candidate },
            ui: { isCandidateLoading },
        },
    } = useClientPublicCandidateContext();

    const status = candidate.highlights
        ? JobCandidateStatus.fromId(candidate.highlights.candidateStatusId)
        : undefined;

    const privateUrl = `/client/candidates/${candidate.job.jobId}/${candidate.highlights.leadId}`;

    if (candidate.redirectToPrivate) window.location.href = privateUrl;

    const giveFeedback = () => {
        localStorage.setItem("relode:redirectUrl", privateUrl);
        window.location.href = Routing.Account.SIGNIN + "?appName=client";
    };
    const renderFooter = (selectedSection: string): React.ReactNode =>
        candidate.showGiveFeedback ? (
            <Button
                size="small"
                color="primary"
                fullWidth
                onClick={giveFeedback}
            >
                give feedback
            </Button>
        ) : null;

    return (
        <MobilePage
            showTabs={true}
            defaultSection="highlights"
            isBusy={isCandidateLoading}
            actions={
                <MobilePageActions
                    title={
                        candidate.highlights
                            ? candidate.highlights.fullName
                            : "n/a"
                    }
                    statusLabel={
                        status ? (
                            <StatusLabel
                                title={status.description}
                                jobCandidateStatus={status}
                            />
                        ) : null
                    }
                />
            }
            footerActions={renderFooter}
        >
            <MobilePageSection label="highlights" id="highlights">
                <CandidateJobDetailsMobile job={candidate.job} />
                <CandidateHighlights
                    highlights={candidate.highlights}
                    qualifications={candidate.qualifications}
                    additionalInfo={candidate.additionalInfo}
                />
                <InterviewAvailability
                    availability={candidate.availability}
                    additionalInfo={candidate.additionalInfo}
                />
                <JobManagerContactDetails
                    title="questions?"
                    jobManagerContact={candidate.jobManager}
                    contactActionVariant="link"
                    leadId={candidate.highlights.leadId}
                    leadName={candidate.highlights.fullName}
                    jobId={candidate.job.jobId}
                    jobName={candidate.job.jobName}
                />
            </MobilePageSection>

            <MobilePageSection label="resume" id="resume">
                <CandidateResumeMobile resume={candidate.formattedResume} />
            </MobilePageSection>
        </MobilePage>
    );
};
